import {
  DatatablesFooter,
  IconButtonDatatable,
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
  SearchInput,
  TableHeader,
} from "App/Component/ui";
import {
  Grid,
  TableRow,
  Table,
  TableContainer,
  TableBody,
  Paper,
} from "@material-ui/core";
import { useDatatables } from "App/hooks";
import { TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { SelectIcon } from "App/Assets";
import { defaultDateDisplay, isNull } from "App/utils/helpers";

import React from "react";
import { headCellsSuplesi, useSearchHistorySepSuplesi } from "./helpers";
import Title from "App/Component/ui/title/Title";

export const TableListSepSuplesi = ({ noBpjs, handleClickSelect }) => {
  const { disabled, handleChange, handleSubmit, filter, rows } =
  useSearchHistorySepSuplesi(noBpjs);

  return (
    <Paper
      className="show-element"
      style={{
        padding: "1rem",
      }}
    >
    <Title title="Pencarian SEP Suplesi" />
      <Grid container spacing={3}>
        <Grid item sm={6}>
          <InputTextMaster
            name="no_bpjs"
            label="NO BPJS"
            id="no_bpjs"
            value={filter.no_kartu_peserta}
            placeholder={"No BPJS"}
            disabled
          />
        </Grid>
        <Grid item sm={6}>
          <InputTextMaster
            name='valid_from'
            label='TANGGAL PELAYANAN'
            id='valid_from'
            type='date'
            autoFocus={true}
            value={filter.tgl_pelayanan}
            onChange={handleChange("tgl_pelayanan")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <MasterButton
          className={"mt-1"}
          type="button"
          onClick={(e) => handleSubmit(e)}
          color={disabled.color}
          name={disabled.label}
          size="md"
        />
      </Grid>

      <TableListSEP rows={rows} handleClickSelect={handleClickSelect} />
    </Paper>
  );
};

export const TableListSEP = ({ rows, handleClickSelect }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    setQ,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "noRegister",
    orderByRow: [
      "noRegister",
      "noSep",
      "noSepAwal",
      "noSuratJaminan",
      "tglKejadian",
      "tglSep",
    ],
  });

  return (
    <>
      <TableContainer
        className="custom-scrollbar "
        style={{
          maxHeight: "400px",
        }}
      >
        <div
          className=""
          style={{
            margin: "1rem 0",
          }}
        >
          <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
        </div>
        <Table
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headCells={headCellsSuplesi}
          />

          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.name}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      width="5%"
                      padding="none"
                      align="center"
                    >
                      <IconButtonDatatable
                        color="secondary"
                        aria-label="delete"
                        onClick={() => handleClickSelect(row)}
                        style={{
                          background: "#D8D8D8",
                          borderRadius: "8px",
                          padding: "6px",
                        }}
                      >
                        <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                    </TableCell>
                    <TableCell>{row?.noRegister}</TableCell>
                    <TableCell>{row?.noSep}</TableCell>
                    <TableCell>{row?.noSepAwal}</TableCell>
                    <TableCell>{row?.noSuratJaminan}</TableCell>
                    <TableCell>
                      {isNull(row?.tglKejadian)
                        ? "-"
                        : defaultDateDisplay(row?.tglKejadian, false)}
                    </TableCell>
                    <TableCell>
                      {isNull(row?.tglSep)
                        ? "-"
                        : defaultDateDisplay(row?.tglSep, false)}
                    </TableCell>
                  </TableRow>
                );
              })}
            {length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCellsSuplesi.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

export default TableListSepSuplesi;
